module.exports = __webpack_public_path__ + "static/img/JinhaiPoker.fe795dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/JinhaiPoker.jpg
// module id = 4bXQ
// module chunks = 0